"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function InfoIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "m12,22.377c-5.722,0-10.377-4.655-10.377-10.377S6.279,1.623,12,1.623s10.376,4.655,10.376,10.377-4.654,10.377-10.376,10.377Zm0-19.055C7.215,3.322,3.323,7.215,3.323,12s3.893,8.678,8.678,8.678,8.677-3.893,8.677-8.678S16.784,3.322,12,3.322Z" }),
        react_1.default.createElement("path", { d: "m10.642,7.362c0-.381.131-.696.395-.949.262-.251.584-.377.964-.377s.702.126.965.377c.262.253.393.568.393.949,0,.369-.131.678-.393.931-.263.251-.584.377-.965.377s-.702-.126-.964-.377c-.263-.253-.395-.562-.395-.931Zm2.449,10.602h-2.182v-8.171h2.182v8.171Z" })));
}
exports.default = InfoIcon;
